import { useContext, useEffect, useRef } from "react";
import { useListContext } from "react-admin";
import { GridUserDataContext } from "contexts/GridUserDataProvider";

export const useSaveUserDataOnSuccess = () => {
	const { error, loading, filterValues, sort } = useListContext();
	const context = useContext(GridUserDataContext);
	const prevLoadingRef = useRef(true);

	useEffect(() => {
		if (!context?.saveFilters || !context?.saveSort) return;

		const loadingCompleted = prevLoadingRef.current && !loading;
		prevLoadingRef.current = loading;

		if (loadingCompleted && !error) {
			if (filterValues) context.saveFilters(filterValues);
			if (sort) context.saveSort(sort);
		}
	}, [error, loading, filterValues, sort, context]);
};
